import { render, staticRenderFns } from "./ViewCounter.vue?vue&type=template&id=4837dae6&scoped=true"
import script from "./ViewCounter.vue?vue&type=script&lang=js"
export * from "./ViewCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4837dae6",
  null
  
)

export default component.exports